"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableItemTitleContainer = exports.SelectableItemContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const SelectableItemContainer = styled_1.default.div `
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.selected
    ? props.theme.colors.primary + '19'
    : props.outlined
        ? props.theme.colors.white
        : props.theme.colors.grey};
  border: ${(props) => (props.outlined ? `1px solid ${props.theme.colors.grey5}` : 'none')};
  padding: 10px 11px 10px 8px;
  align-items: center;
  border-radius: 4px;
  margin: 4px 0px;

  ${(props) => props.leftIndicatorBarColor && `border-left: 8px solid ${props.theme.colors[props.leftIndicatorBarColor]}`}
`;
exports.SelectableItemContainer = SelectableItemContainer;
const SelectableItemTitleContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  text-align: left;
  margin-right: 14px;
`;
exports.SelectableItemTitleContainer = SelectableItemTitleContainer;
